import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import { api } from "../../../utils/Api";
import { omit } from "lodash";
import { useParams } from "react-router-dom";

let myModal = {};

export default function ModalServiceView(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [service_filter, SetServiceFilter] = useState();
  const [service_data, SetServiceData] = useState([]);

  useEffect(() => {
    console.log("ModalServiceView On mount :", props);
    let myModal1 = document.getElementById("ServiceViewModel");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("close_data :", close_data);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ModalServiceView On Open :", props);
      myModal = new bootstrap.Modal(
        document.getElementById("ServiceViewModel"),
        {}
      );
      SetServiceFilter("unaccepted");
      let item = close_data;
      item.action = "close";
      item.filter_value = props.filter_value;
      SetCloseData(item);
      get_services();

      myModal.show();
    }
  }, [props.open]);

  useEffect(() => {
    console.log("service_filter On change :", service_filter);
    get_services();
  }, [service_filter]);

  async function get_services() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: props.data.id,
      },
    };
    if (service_filter != "unaccepted") {
      pass_data.get.filter = service_filter;
    }
    console.log("pass_data :", pass_data);
    let data = await api("/outlet/order_service_request", pass_data);
    console.log("order_service_request response :", data);
    if (data.response.hasOwnProperty("services")) {
      let service_data_value = data.response.services;
      if (service_filter == "unaccepted") {
        service_data_value.map((ele: any, index: any) => {
          ele.checked = true;
        });
      }

      SetServiceData(service_data_value);
    } else {
      SetServiceData([]);
    }
  }

  async function accept_service() {
    let selected_service = [];
    service_data.map((ele: any, index: any) => {
      if (ele.checked) {
        selected_service.push(ele.id);
      }
    });
    let pass_data = {
      get: { brand: id_value.brand_id, outlet: id_value.outlet_id },
      post: {
        order_id: props.data.id,
        services: selected_service,
      },
    };
    console.log("accept_service pass data :", pass_data);
    let data = await api("/outlet/accept_order_service_request", pass_data);
    console.log("accept_order_service_request response :", data);
    if (data.response.hasOwnProperty("status")) {
      if (Object.keys(data.response.status).length > 0) {
        get_services();
      }
    }
  }

  async function reject_service(service_id_value: any) {
    let pass_data = {
      get: { brand: id_value.brand_id, outlet: id_value.outlet_id },
      post: {
        order_id: props.data.id,
        service_id: service_id_value,
      },
    };
    console.log(" reject_service pass data :", pass_data);
    let data = await api("/outlet/reject_service_request", pass_data);
    console.log("reject_service_request response :", data);
    if (data.response.hasOwnProperty("status")) {
      if (data.response.status) {
        get_services();
      }
    }
  }

  function capitalizeFirstLetter(string: any) {
    if (string != undefined) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }

  return (
    <div
      className="modal fade"
      id="ServiceViewModel"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="shadow">
            <div className="modal-header">
              <div className="modal-title" id="ModalLabel">
                <h5>Service View List</h5>
              </div>

              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => {
                  let item = close_data;
                  item.action = "close";
                  item.filter_value = props.filter_value;
                  SetCloseData(item);
                  myModal.hide();
                }}
              ></button>
            </div>
            <nav className="sticky-tabs p-2 ">
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  className={
                    service_filter == "unaccepted"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  id="unaccepted-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#unaccepted"
                  type="button"
                  role="tab"
                  aria-controls="unaccepted"
                  aria-selected="true"
                  onClick={() => {
                    SetServiceFilter("unaccepted");
                  }}
                >
                  Unaccepted
                </button>
                <button
                  className={
                    service_filter == "accepted"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  id="accepted-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#accepted"
                  type="button"
                  role="tab"
                  aria-controls="accepted"
                  aria-selected="false"
                  onClick={() => {
                    SetServiceFilter("accepted");
                  }}
                >
                  Accepted
                </button>
                <button
                  className={
                    service_filter == "rejected"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  id="rejected-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#rejected"
                  type="button"
                  role="tab"
                  aria-controls="rejected"
                  aria-selected="false"
                  onClick={() => {
                    SetServiceFilter("rejected");
                  }}
                >
                  Rejected
                </button>
                <button
                  className={
                    service_filter == "cancelled"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  id="cancelled-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#cancelled"
                  type="button"
                  role="tab"
                  aria-controls="cancelled"
                  aria-selected="false"
                  onClick={() => {
                    SetServiceFilter("cancelled");
                  }}
                >
                  Cancelled
                </button>
              </div>
            </nav>
          </div>
          <div className="modal-body pt-0">
            {/* Unaccepted */}
            {/* accepted */}
            {/* rejected */}
            {/* cancelled */}

            <div className="row pt-4 users_scroll">
              {service_data.length > 0 ? (
                service_data.map((s_ele: any, s_index: any) => (
                  <div className="" key={s_index}>
                    <div className="d-flex">
                      {service_filter == "unaccepted" &&
                      (props.filter_value == "unaccepted" ||
                        props.filter_value == "accepted") ? (
                        <input
                          type="checkbox"
                          className="ms-2"
                          checked={s_ele.checked}
                          onChange={() => {
                            SetServiceData((prevValue) => {
                              prevValue[s_index].checked =
                                !prevValue[s_index].checked;
                              return [...prevValue];
                            });
                          }}
                        />
                      ) : null}
                      <h6 className="fs-6 text-dark">
                        {s_ele.service_name}{" "}
                        {s_ele.quantity_type == "1"
                          ? "(Item Wise)"
                          : "(Duration Wise)"}
                      </h6>
                    </div>
                    <div className="d-flex align-items-center">
                      <small>{s_ele.created_at}</small>
                      <div className="ms-auto">
                        <p className="text-primary">{s_ele.status}</p>
                      </div>
                    </div>
                    <p className="text-dark">
                      Created By : {s_ele.created_user} @{" "}
                      {s_ele.created_username}
                    </p>
                    {service_filter == "unaccepted" ? (
                      <div className="text-end w-100">
                        <button
                          className="btn btn-light-outline"
                          onClick={() => {
                            reject_service(s_ele.id);
                          }}
                        >
                          Reject
                        </button>
                      </div>
                    ) : null}
                    <hr />
                  </div>
                ))
              ) : (
                <div className="text-center">
                  <img
                    src={require("../../../assets/img/svg/no_data_2.svg")}
                    className="w-30 pb-2"
                  />
                  <p className="v-small mb-0">
                    No {capitalizeFirstLetter(service_filter)} Data
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                item.filter_value = props.filter_value;
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            {service_filter == "unaccepted" &&
            (props.filter_value == "unaccepted" ||
              props.filter_value == "accepted") ? (
              <button
                type="button"
                className="btn btn-light-outline"
                onClick={() => {
                  console.log("Accept");
                  accept_service();
                }}
              >
                Accept
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
